import _axios from '@/http/axios_init.js';

const install = (app) => {
   
  app.config.globalProperties.$http = _axios;
};

export default { install };
